import { api } from '@/api/http'
import type { Conversation, ChatMessage, StartConversationPayload } from '../types/chat.types'

export const chatService = {
  startConversation: (payload: StartConversationPayload) =>
    api.post<Conversation>('/chat/conversations', payload),

  getConversations: () =>
    api.get<Conversation[]>('/chat/conversations'),

  getConversation: (id: number) =>
    api.get<Conversation>(`/chat/conversations/${id}`),

  getMessages: (conversationId: number) =>
    api.get<ChatMessage[]>(`/chat/conversations/${conversationId}/messages`),

  sendMessage: (conversationId: number, content: string) =>
    api.post<ChatMessage>(`/chat/conversations/${conversationId}/messages`, { content }),

  markAsRead: (conversationId: number) =>
    api.patch<{ success: boolean }>(`/chat/conversations/${conversationId}/read`),

  markDealDone: (conversationId: number) =>
    api.patch<Conversation>(`/chat/conversations/${conversationId}/deal-done`),
}
